import * as React from 'react'
import { Button, CardBody } from 'reactstrap'
import { VCSpinner } from '../shared/spinner'

const { I18n } = window as any

interface TwoFactorEnabledViewProps {
  loading: boolean
  disable2FA: () => void
  canDisable?: boolean
}

function TwoFactorEnabledView({ loading, disable2FA, canDisable = true }: TwoFactorEnabledViewProps): JSX.Element {
  const handleDisableClick = () => {
    if (window.confirm(I18n.t('users.two_factor.confirm_disable'))) {
      disable2FA()
    }
  }

  return (
    <CardBody>
      <div>
        <span>{I18n.t('users.two_factor.enabled_message')}</span>
      </div>

      {canDisable && (
        <Button className="mt-2" color="outline-danger" onClick={handleDisableClick} disabled={loading}>
          {loading ? (
            <VCSpinner visible={loading} viewType="inline" size="1" />
          ) : (
            I18n.t('users.two_factor.disable_button')
          )}
        </Button>
      )}
    </CardBody>
  )
}

export default TwoFactorEnabledView
